// Configuration for the frontend application

export const config = {
  // Backend API URL - can be overridden by environment variable
  API_URL: process.env.REACT_APP_API_URL || "http://localhost:8000",

  // Request timeout in milliseconds
  REQUEST_TIMEOUT: 60000,

  // Maximum message length
  MAX_MESSAGE_LENGTH: 1000,

  // Auto-scroll behavior
  AUTO_SCROLL: true,
};
